// extracted by mini-css-extract-plugin
module.exports = {"PostTeasers__root":"_54RW","PostTeasers__items":"_8B_Z","PostTeasers__item":"Lrgf"};